export default "__VITE_ASSET__Cy1SttGe__"